import { ChangeDetectionStrategy, Component, EventEmitter, input, model, OnChanges, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog'
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ReportForest } from 'src/app/models/reportForest.model';

@Component({
  selector: 'app-submission',
  templateUrl: './submission.component.html',
  styleUrls: ['./submission.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})


export class SubmissionComponent implements OnChanges, OnInit {
  report = input.required<any>();
  is_co = input.required<boolean>();
  nav = model.required<string>();
  @Output() loaded = new EventEmitter();

  constructor(
    public dialog: MatDialog,
    private readonly titleService: Title,
    private readonly router: Router,
    private readonly formBuilder: FormBuilder,
  ) {
    this.titleService.setTitle("BAER - Report Submitted")
  }

  ngOnInit(): void {
    this.report().forests.forEach((forest: ReportForest) => {
      forest.line_officer.baer_roles = forest.line_officer.baer_roles.filter((role: any) => {
        return role.baer_role.type == "FOLO"
      }).map((role: any) => role.baer_role?.text)
      forest.line_officer.baer_roles = [...new Set(forest.line_officer.baer_roles)]
    })
    this.loaded.emit(true);
  }

  ngOnChanges(): void {
    if (this.nav() != '') this.navigate();
  }

  navigate() {
    if (this.nav() == 'close') {
      this.router.navigate(['fire-overview'], { queryParams: { assessment_id: this.report().assessment_id } });
    }
  }
}
